import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { DashboardProvider } from "../dashboard.provider";
import { PatientListProvider } from "../../../../../../../shared/cw-backend/providers/register/operational/patient/patient-list.provider";
import { MatDialog } from "@angular/material/dialog";
import { DashboardSingle } from "../../../../../../../shared/cw-backend/models/dashboard/DashboardSingle";
import { FormControl, FormGroup } from "@angular/forms";
import { PageOptions } from "../../../../../../../shared/cw-utils/cw-utils.service";
import moment from "moment";
import { PatientEvolutionComponent } from "app/main/modules/operational/medical-module/components/patient-evolution/patient-evolution.component";
import {
    Company,
    Performer,
} from "../../../../../../../shared/cw-backend/models/backend-definitions.module";
import { ProfessionalListProvider } from "../../../../../../../shared/cw-backend/providers/organizational/professional/professional-list.provider";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";

import { fuseAnimations } from "@fuse/animations";
import { RolePermissionService } from "../../../../../../../shared/cw-services/role/role-permission.service";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

@Component({
    selector: "app-dashboard-performer",
    templateUrl: "./dashboard-performer.component.html",
    styleUrls: ["./dashboard-performer.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DashboardPerformerComponent implements OnInit, AfterViewInit {
    @ViewChild("targetDiv") targetDiv!: ElementRef;
    @Input("company") company: Company;
    @Input("performer") performer: any;
    private _unsubscribeAll: Subject<any>;
    dashboardInsuranceList = new Array<DashboardSingle>();
    dashboardAgeRangeList = new Array<DashboardSingle>();
    performerCtrl = new FormControl("");
    performerSelection = new Array();
    performerList: any;
    user: any;
    performerPageOptions: PageOptions;

    scheduleStatusGroup = new FormGroup({
        dateStart: new FormControl(this.getWeekSunday()),
        dateEnd: new FormControl(this.getWeekSaturday()),
    });

    scheduleAnamneseGroup = new FormGroup({
        dateStart: new FormControl(this.getWeekSunday()),
        dateEnd: new FormControl(this.getWeekSaturday()),
    });

    scheduleStatusValues = {
        total: "0",
        free: "0",
        cancel: "0",
        done: "0",
        oters: "0",
    };

    scheduleAnamneseValues = {
        scheduleDone: "0",
        documentDone: "0",
    };

    scheduleAnamneseDetailValues = new Array<{
        schedulePatientId: "0";
        scheduleDate: "0";
        patientName: "0";
        documentPatientId: "0";
        documentDate: "0";
    }>();
    /*= ;*/

    schemePieChart = {
        domain: [
            "#063254",
            "#0C695D",
            "#2D8E87",
            "#37AFA9",
            "#849FAD",
            "#AEC0C9",
        ],
    };

    scheduleAnamnesePage: PageOptions;

    datailScheduleAnamnese: boolean = false;

    //tabela
    totalElements = 0;
    pagina = 0;
    tamanho = 0;
    constructor(
        private dashboardProvider: DashboardProvider,
        private patientListProvider: PatientListProvider,
        private performerListProvider: ProfessionalListProvider,
        private rolePermissionService: RolePermissionService,
        private progressBar: FuseProgressBarService,

        public dialog: MatDialog
    ) {
        this.scheduleAnamnesePage = new PageOptions();
        this.performerPageOptions = new PageOptions();
        this._unsubscribeAll = new Subject();
        this.user = JSON.parse(localStorage.getItem("user"));
    }

    ngAfterViewInit(): void {
        this.rolePermissionService
            .rolePermissions("application-dashboards-admin")
            .then(() => {
                setTimeout(() => {}, 500);
            });

        this.rolePermissionService.formEvent
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((formGroup) => {
               console.log("🚀 ~ DashboardPerformerComponent ~ .subscribe ~ formGroup:", formGroup)
               
                   
                
            });
    }

    ngOnInit() {
        this.observableDate();
        this.getPerformerList();
        this.filterPerformer();
        this.getPerformerById();
    }


    async getPerformerById() {
        this.progressBar.show();
        if (this.user?.performerId) {
            this.performerListProvider
                .getPerformerById(this.user?.performerId)
                .subscribe((performer) => {
                    this.performerCtrl.setValue(performer.body);        
                    this.performer = performer.body;
                    this.progressBar.hide();   
                    this.getAll();        
                });
        } else {
            /* this._router.navigate(
                 [`aplicacao/dashboards/admin`]
             );
             this.snackBar.warnMessage('Acesso permitido somente para médicos.')*/
            this.progressBar.hide();
        }
    }

    getAll() {
        this.getDashboardInsuraceByProfessional();
        this.getDashboardAgeRangeByProfessional();
        this.getDashboardScheduleStatusByPerformer();
        this.getDashboardScheduleAnamneseByPerformer();
        this.getDashboardScheduleAnamneseByPerformerDetail();
    }

    getDashboardInsuraceByProfessional() {
        this.dashboardProvider
            .findInsuranceByPatientCareAndPerformer(this.performer.id)
            .then((response) => {
                this.dashboardInsuranceList = response.body;
            });
    }

    getDashboardAgeRangeByProfessional() {
        this.dashboardProvider
            .findAgeRangeByPatientCareAndPerformer(this.performer.id)
            .then((response) => {
                this.dashboardAgeRangeList = response.body;
            });
    }

    getDashboardScheduleStatusByPerformer() {
        let dateStart = moment(
            this.scheduleStatusGroup.controls["dateStart"].value
        )
            .format("YYYY-MM-DD")
            .toString();
        let dateFinish = moment(
            this.scheduleStatusGroup.controls["dateEnd"].value
        )
            .format("YYYY-MM-DD")
            .toString();

        this.dashboardProvider
            .getDashboardScheduleStatusByPerformerAndCompany(
                dateStart,
                dateFinish,
                this.company.id,
                this.performer.id
            )
            .then((response) => {
                this.scheduleStatusValues = response.body[0];
            });
    }

    getDashboardScheduleAnamneseByPerformer() {
        let dateStart = moment(
            this.scheduleAnamneseGroup.controls["dateStart"].value
        )
            .format("YYYY-MM-DD")
            .toString();
        let dateFinish = moment(
            this.scheduleAnamneseGroup.controls["dateEnd"].value
        )
            .format("YYYY-MM-DD")
            .toString();

        this.dashboardProvider
            .getDashboardScheduleAnamneseByPerformerAndCompany(
                dateStart,
                dateFinish,
                this.company.id,
                this.performer.id
            )
            .then((response) => {
                this.scheduleAnamneseValues = response.body[0];
            });
    }

    getDashboardScheduleAnamneseByPerformerDetail(event?, type?) {
        switch (type) {
            case "short":
                this.scheduleAnamnesePage.fieldSort = event.active;
                this.scheduleAnamnesePage.sortDirection = event.direction;
                break;
            case "page":
                this.scheduleAnamnesePage.page = event.pageIndex;
                this.scheduleAnamnesePage.sizePage = event.pageSize;
                break;

            default:
                this.scheduleAnamnesePage.page = 0;
                this.scheduleAnamnesePage.sizePage = 5;
                break;
        }

        let dateStart = moment(
            this.scheduleAnamneseGroup.controls["dateStart"].value
        )
            .format("YYYY-MM-DD")
            .toString();
        let dateFinish = moment(
            this.scheduleAnamneseGroup.controls["dateEnd"].value
        )
            .format("YYYY-MM-DD")
            .toString();

        this.dashboardProvider
            .getDashboardScheduleAnamneseByPerformerAndCompanyDetail(
                dateStart,
                dateFinish,
                this.company.id,
                this.performer.id,
                this.scheduleAnamnesePage
            )
            .then((response) => {
                console.log(
                    "🚀 ~ ProfessionalStatisticsComponent ~ .then ~ response:",
                    response
                );
                this.scheduleAnamneseDetailValues = response.body.content;
                this.totalElements = response.body.totalElements;
                this.pagina = response.body.number;
            });
    }

    getWeekSunday() {
        const today = new Date();
        const currentDay = today.getDay();

        const sunday = new Date(today);
        sunday.setDate(today.getDate() - currentDay);

        return sunday;
    }

    getWeekSaturday() {
        const today = new Date();
        const currentDay = today.getDay();

        const saturday = new Date(today);
        saturday.setDate(today.getDate() + (6 - currentDay));

        return saturday;
    }

    observableDate() {
        this.scheduleStatusGroup.controls["dateEnd"].valueChanges
            .pipe()
            .subscribe((res) => {
                if (res) {
                    this.getDashboardScheduleStatusByPerformer();
                }
            });

        this.scheduleAnamneseGroup.controls["dateEnd"].valueChanges
            .pipe()
            .subscribe((res) => {
                if (res) {
                    this.getDashboardScheduleAnamneseByPerformer();
                    this.getDashboardScheduleAnamneseByPerformerDetail();
                }
            });
    }

    datailScheduleAnamneseList() {
        this.datailScheduleAnamnese = !this.datailScheduleAnamnese;

        setTimeout(() => {
            // Aguarda a renderização da div antes de rolar
            this.targetDiv.nativeElement.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 0);
    }

    openAddDocument(scheduleAnamnese?: any) {
        console.log(scheduleAnamnese);
        this.patientListProvider
            .getById(scheduleAnamnese.schedulePatientId)
            .subscribe((res) => {
                const confirmDialogRef = this.dialog.open(
                    PatientEvolutionComponent,
                    {
                        data: {
                            type: 4,
                            nameDocument: "Anamnsese",
                            documentList: [],
                            patient: res.body,
                            company: this.company,
                            performer: this.performer,
                            documentId: null,
                            dateSchedule: scheduleAnamnese.scheduleDate,
                        },
                        autoFocus: false,
                        width: "100%",
                        maxWidth: "100%",
                        height: "100%",
                        disableClose: true,
                    }
                );

                confirmDialogRef.afterClosed().subscribe((result) => {
                    this.getDashboardScheduleAnamneseByPerformerDetail();
                });
            });
    }

    getPerformerList() {
        this.performerPageOptions.fieldSort = "professional.person.name";

        this.performerListProvider
            .getPerformerAllPageNoEntity(this.performerPageOptions)
            .then((res) => {
                this.performerList = res.body.content;
                console.log(this.performerList);
                //this.performerCtrl.setValue(this.performerList[0]);
            });
    }

    displayFn(performer?: any): string | undefined {
        if (
            performer &&
            performer.professional &&
            performer.professional.person.name
        ) {
            return performer.professional.person.name;
        } else if (performer && performer.person) {
            return performer.person.name;
        }
        return "";
    }

    filterPerformer() {
        this.performerCtrl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                if (res.name) {
                } else if (res.professional) {
                    this.performerPageOptions.argument =
                        res.professional.person.name;
                } else if (res) {
                    this.performerPageOptions.argument = res;
                } else {
                    this.performerPageOptions.argument = "";
                }
                this.getPerformerList();
            });
    }

    performerSelected(performer) {
        this.performer = performer.option.value;
        this.getAll();
    }
}
